import { FormControl, InputLabel, OutlinedInput, Select } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import { useEffect, useState } from 'react';
import IngredientAPI from '../services/ingredient.api.services';
import useAlert from './Alert/useAlert';

export const IngredientSelector = ({customer, onChange, reloadIngredients}) => {
    const {showErrorAlert} = useAlert();
    const [inputValue, setInputValue] = useState([]);
    const [ingredients, setIngredients] = useState([]);

    const loadIngredients = async () => IngredientAPI
        .getIngredients(customer.id)
        .then(result => setIngredients(result.items))
        .catch(err => showErrorAlert(err.response.data.message));

    useEffect(() => { customer && loadIngredients() }, [customer]);

    reloadIngredients(loadIngredients);

    const handleChange = ({target: {value}}) => {
        const inputValue = typeof value === 'string' ? value.split(',') : value;
        setInputValue(inputValue);
        onChange(value);
    }

    return (
        <FormControl fullWidth sx={{mb: 1, mt: 1}} required>
            <InputLabel sx={{top: '-0.25rem'}} id="multiple-name">
                NFTBasicIngredients
            </InputLabel>
            <Select
                labelId="multiple-name"
                id="nftBasicIngredients"
                name="nftBasicIngredients"
                multiple
                size="small"
                value={inputValue}
                onChange={handleChange}
                input={<OutlinedInput label="NFTBasicIngredients"/>}
            >
                {ingredients.map(ingredient => (
                    <MenuItem style={{justifyContent: 'space-between'}} key={ingredient.id} value={ingredient.id}>
                        <span>{ingredient.name}</span>
                        <span> ({ingredient.quantity})</span>
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}
